import * as React from "react";
import Radio from "@sproutsocial/seeds-react-radio";
import Checkbox from "@sproutsocial/seeds-react-checkbox";
import {
  ComboboxItem as StyledItem,
  ComboboxItemIndicator,
} from "./ComboboxStyles";
import { CheckIcon } from "./SelectIcons";

interface ComboboxItemProps<T> {
  value: T;
  itemId: string;
  label: string;
  disabled?: boolean;
  inputType?: "icon" | "radio" | "checkbox" | "none";
  renderItem?: () => React.ReactNode;
  index?: number;
  "data-index"?: number;
  style?: React.CSSProperties;
}

function ComboboxItemInner<T>(
  {
    value,
    itemId,
    label,
    disabled,
    inputType = "icon",
    renderItem,
    index,
    "data-index": dataIndex,
    style,
  }: ComboboxItemProps<T>,
  ref: React.Ref<HTMLDivElement>
) {
  return (
    <StyledItem
      value={value}
      index={index}
      data-index={dataIndex}
      style={style}
      ref={ref}
      disabled={disabled}
      data-qa-menu-item={label}
    >
      {inputType === "radio" ? (
        <ComboboxItemIndicator
          keepMounted
          render={(_props, state) => (
            <Radio
              checked={state.selected}
              onChange={() => {}}
              tabIndex={-1}
              id={`radio-${itemId}`}
              name="combobox-item"
            />
          )}
        />
      ) : inputType === "checkbox" ? (
        <ComboboxItemIndicator
          keepMounted
          render={(_props, state) => (
            <Checkbox
              checked={state.selected}
              onChange={() => {}}
              tabIndex={-1}
              id={`checkbox-${itemId}`}
              name="combobox-item"
            />
          )}
        />
      ) : inputType === "icon" ? (
        <ComboboxItemIndicator keepMounted>
          <CheckIcon />
        </ComboboxItemIndicator>
      ) : null}
      <span>{renderItem ? renderItem() : label}</span>
    </StyledItem>
  );
}

const ComboboxItem = React.forwardRef(ComboboxItemInner) as <T>(
  props: ComboboxItemProps<T> & { ref?: React.Ref<HTMLDivElement> }
) => React.ReactElement;

export default ComboboxItem;
